export default __webpack_public_path__ + "media/images/front/about/facebook-59cf87982fa12bebef990c5627dca3ab.png";